import { Fragment, FunctionComponent } from 'react';

/**
 * Composant ReadOnlyDate.
 *
 * @param label - Libellé du champ de saisie en lecture seule.
 * @param value - Valeur du champ de saisie en lecture seule.
 * @param error - Indique si le champ de saisie en lecture seule a une erreur.
 * @return Composant ReadOnlyDate.
 */
export const ReadOnlyDate: FunctionComponent<{
  error?: boolean;
  label?: string;
  value?: string | number | readonly string[] | null;
}> = ({ label, value, error = false }) => {
  return (
    <Fragment>
      {label && <label className={`text-xs ${error ? 'text-red-500' : ''}`}>{label}</label>}
      <p className={`text-gray-600 items-center text-sm py-2 px-4 border border-gray-200 rounded cursor-not-allowed ${error ? 'text-red-500' : ''}`}>
        {value !== undefined && value !== null && value !== ''
          ? new Intl.DateTimeFormat('default', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }).format(new Date(value as string))
          : 'Non renseigné'}
      </p>
    </Fragment>
  );
};
